<template>
  <div class="weui-search-bar" :class="{'weui-search-bar_focusing':focuing}">
    <form class="weui-search-bar__form" v-on:submit.prevent="onSubmit">
      <div class="weui-search-bar__box">
        <i class="weui-icon-search"></i>
        <input
          type="search"
          class="weui-search-bar__input"
          :placeholder="placeholder"
          v-model="keyword"
          v-on:blur="onBlur"
          ref="input"
        />
        <a href="javascript:" class="weui-icon-clear" @click="clear"></a>
      </div>
      <label class="weui-search-bar__label" @click="focus">
        <i class="weui-icon-search"></i>
        <span>{{placeholder}}</span>
      </label>
    </form>
    <a href="javascript:" class="weui-search-bar__cancel-btn" @click="cancel">取消</a>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "搜索"
    },
    name: String,
    // change后自动触发search
    autoSearch: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      focuing: false,
      keyword: null
    };
  },
  watch: {
    keyword(value) {
      if (this.autoSearch && this.$refs.input == document.activeElement) {
        this.$emit("search", value);
      }
    },
  },
  methods: {
    focus() {
      var me = this,
        input = me.$refs.input;
      me.focuing = true;
      input.focus();
      me.$emit("focus", true);
    },
    clear() {
      var me = this,
        input = me.$refs.input;
      input.value = "";
      this.keyword = null
      input.focus();
      me.$emit("search", input.value);
    },
    cancel() {
      var me = this,
        input = me.$refs.input;
      me.focuing = false;
      input.value = "";
      this.keyword = ""
      me.onSubmit();
      me.$emit("focus", false);
    },
    onSubmit() {
      var me = this,
        input = me.$refs.input,
        value = input.value;
      input.blur();
      me.$emit("search", value);
    },
    onBlur() {
      var me = this,
        input = me.$refs.input,
        value = input.value;
      if (!value) {
        me.focuing = false;
        me.$emit("focus", false);
      }
    },
    getValue() {
      return this.$refs.input.value;
    },
    getCondition() {
      var me = this,
        name = me.name,
        value = me.getValue();
      if (name && value) {
        var fields = [];
        if (name.indexOf(",") > 0) {
          fields = name.split(",");
        } else {
          fields.push(name);
        }
        return {
          type: "condition",
          value:
            "(" +
            fields.map(field => field + ` like '%${value}%'`).join(" or ") +
            ")"
        };
      }
      return null;
    }
  }
};
</script>